<template>
    <div class="page">
        <div class="content" :style="{backgroundImage: `url(${bgUrl})`}">
            <!--头部-->
            <div class="topHead">
                <topComponent :title="state.title"></topComponent>
            </div>
            <!-- <div @click="cancelAllRequests" style="cursor: pointer;">取消</div> -->
            <div class="container-row">
                <el-row>
                    <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
                        <div class="left-col">
                            <div style="width: 100%; min-height:452px" class="boxbgimage firstContainer">
                                <img class="flashing2" src="../assets/image/flashing2.png">
                                 <el-row :gutter="0" class="col-3-box-h">
                                    <!--近5届毕业生数量对比-->
                                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                        <div class="title">
                                            <div class="tag"></div>
                                            <div class="text">近5届毕业生数量对比</div>
                                        </div>
                                        <div class="echartBox">
                                            <div class="echart_padding" style="height: 170px;" ref="echart1"></div>
                                        </div>
                                    </el-col>
                                    <!--近5届毕业生就业率-->
                                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                        <div class="title">
                                            <div class="tag"></div>
                                            <div class="text">近5届毕业生就业率</div>
                                        </div>
                                        <div class="echartBox">
                                            <div class="echart_padding" style="height: 170px;" ref="echart2"></div>
                                        </div>
                                    </el-col>
                                    <!--近5年累计双选会举办场次-->
                                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                        <div class="title">
                                            <div class="tag"></div>
                                            <div class="text">近5年累计双选会举办场次</div>
                                        </div>
                                        <div class="echartBox">
                                            <div style="width: 100%;height: 170px;" ref="echart3"></div>
                                        </div>
                                    </el-col>

                                    <!--近5年累计宣讲会举办场次-->
                                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-show="echart4Show">
                                        <div class="title">
                                            <div class="tag"></div>
                                            <div class="text">近5年累计宣讲会举办场次</div>
                                        </div>
                                        <div class="echartBox">
                                            <div style="width: 100%;height: 170px;" ref="echart4"></div>
                                        </div>
                                    </el-col>

                                </el-row>
                            </div>
                            <div style="width: 100%;  min-height:456px;margin-top: 26px" class="boxbgimage firstContainer sou-tag-box" >
                                <img class="sou-tag" src="../assets/image/line.png">
                                <el-row :gutter="0" class="col-3-box-h">
                                    <!--近5届毕业生数量对比-->
                                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                        <div class="title">
                                            <div class="tag"></div>
                                            <div class="text">意向行业</div>
                                        </div>
                                        <div class="echartBox">
                                            <div style="width: 100%;height: 170px;" ref="echart5"></div>
                                        </div>
                                    </el-col>
                                    <!--近5届毕业生就业率-->
                                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                        <div class="title">
                                            <div class="tag"></div>
                                            <div class="text">意向薪资</div>
                                        </div>
                                        <div class="echartBox">
                                            <div style="width: 100%;height: 170px;" ref="zhiweileibieChart"></div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                        <div class="center-col">
                            <div class="top-col">
                                <el-row :gutter="0" class="col-3-box-h">
                                        <el-col :xs="6" :sm="6" >
                                            <div class="title">毕业生总量</div>
                                            <div class="val">{{mainDataObj.student_count}}</div>
                                        </el-col>
                                        <el-col :xs="4" :sm="4">
                                            <div class="title">供需比</div>
                                            <div class="val">{{mainDataObj.ratio}}</div>
                                        </el-col>
                                        <el-col :xs="7" :sm="7">
                                            <div class="title">合作企业数量</div>
                                            <div class="val">{{mainDataObj.department_count}}</div>
                                        </el-col>
                                        <el-col :xs="7" :sm="7">
                                            <div class="title">累计提供岗位</div>
                                            <div class="val">{{mainDataObj.intent_count}}</div>
                                        </el-col>
                                </el-row>
                            </div>
                            <!--地图-->
                            <div class="mapContainer " style="position: relative">
                                <!--大屏-->
                                <div class="map-rank pc">
                                    <div class="title">
                                        <div class="tag"></div>
                                        <div class="text">求职意向地域</div>
                                    </div>
                                    <div  class="zhu-chart">
                                        <div v-if="!isHenan">
                                            <div class="item" v-for="(item,index) in mapList" :key="index" >
                                                    <div style="display: flex" v-if="index<10">
                                                        <div :class="{true: 'tag1', false: 'tag'}[index > 2]">{{index+1}}</div>
                                                        <div class="text">{{item.name}}</div>
                                                    </div>
                                                    <el-tooltip  effect="light" :content="item.count" placement="top">
                                                    <div class="widthBox" >
                                                        <div class="width" style="display: flex;" v-if="index<10">
                                                            <div :class="{true: 'width-item1', false: 'width-item'}[index > 2]" :style="'width:'+item.radio * 100+'%'"></div>
                                                        </div>
                                                    </div>
                                                </el-tooltip>
                                            </div>
                                        </div>
                                        <div v-if="isHenan">
                                            <div class="item" v-for="(item,index) in henanmapList" :key="index">
                                                <div style="display: flex" v-if="index<10" >
                                                    <div :class="{true: 'tag1', false: 'tag'}[index > 2]">{{index+1}}</div>
                                                    <div class="text">{{item.name}}</div>
                                                </div>
                                                <el-tooltip  effect="light" :content="item.count" placement="top">
                                                 <div class="widthBox" >
                                                    <div class="width" style="display: flex;" v-if="index<10">
                                                        <div :class="{true: 'width-item1', false: 'width-item'}[index > 2]" :style="'width:'+item.radio * 100+'%'"></div>
                                                    </div>
                                                </div>
                                                </el-tooltip>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!--小屏适配-->
                                <div class="sml" @click="showBox">查看意向地域<img src="../assets/image/alert.png"></div>

                                <div class="echart_padding mapEcharts" style="width:90%;height: 550px" ref="mapEcharts" :class="isHenan?'activenone':''" ></div>
                                <div class="echart_padding mapEcharts" style="width:90%;height: 550px" ref="henanmapEcharts" :class="!isHenan?'activenone':''" ></div>
                            </div>
                            <div class="center-bottom-col">
                                    <img class="line_ex" src="../assets/image/line_ex.png">
                                    <div class="title">
                                        <div class="tag"></div>
                                        <div class="text">本校毕业生热搜词</div>
                                    </div>
                                    <div style="width:100%;height: 210px;z-index:1;position: relative;" ref="hotSea"></div>
                                    <img src="../assets/image/hot_bg.png">
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
                        <div class="right-col">
                         <div style="width: 100%;min-height: 934px" class="boxbgimage">
                             <img class="line_ex" src="../assets/image/line_ex.png">
                             <div class="right-item-col">
                                 <div class="title">
                                    <div class="tag"></div>
                                    <div class="text">合作企业行业分布</div>
                                 </div>
                                 <div class="echart_padding" style="width:100%;height: 221px;" ref="industryEcharts"></div>
                             </div>
                             <div class="right-item-col active">
                                 <div class="title">
                                    <div class="tag"></div>
                                    <div class="text">合作企业规模分布</div>
                                 </div>
                                 <div class="animation_1">
                                     <img src="../assets/image/stu_rings1.png" />
                                 </div>
                                 <div class="guimoEcharts active" style="width:100%;height: 230px;" ref="guimoEcharts"></div>
                             </div>
                             <div class="right-item-col ">
                                 <div class="title">
                                    <div class="tag"></div>
                                    <div class="text">合作企业性质分布</div>
                                 </div>

                                 <div class="guimoEcharts active" style="width:100%;height: 275px;" ref="xingzhiEcharts"></div>
                             </div>

                         </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

        <!--小屏弹出层-->
        <div class="alertBox" :class="dialogVisible?'active':''" @click="closBox">
                <div class="map-rank">
                     <div class="title">
                        <div class="tag"></div>
                        <div class="text">求职意向地域</div>
                     </div>
                     <div  class="zhu-chart">
                        <div v-if="!isHenan">
                            <div class="item" v-for="(item,index) in mapList" :key="index">
                                <div style="display: flex" v-if="index<10">
                                    <div :class="{true: 'tag1', false: 'tag'}[index > 2]">{{index+1}}</div>
                                    <div class="text">{{item.name}}</div>
                                </div>
                                <div class="width active" v-if="index<10">
                                    <div :class="{true: 'width-item1', false: 'width-item'}[index > 2]" :style="'width:'+item.radio * 100+'%'"></div>
                                </div>
                            </div>
                        </div>
                        <div v-if="isHenan">
                            <div class="item" v-for="(item,index) in henanmapList" :key="index">
                                <div style="display: flex" v-if="index<10">
                                    <div :class="{true: 'tag1', false: 'tag'}[index > 2]">{{index+1}}</div>
                                    <div class="text">{{item.name}}</div>
                                </div>
                                <div class="width active" v-if="index<10">
                                    <div :class="{true: 'width-item1', false: 'width-item'}[index > 2]" :style="'width:'+item.radio * 100+'%'"></div>
                                </div>
                            </div>
                        </div>
                     </div>
                </div>
        </div>
    </div>

</template>

<script>
    import {ref,onMounted,reactive,onBeforeUnmount} from 'vue'
    import basicApi from '../public/http/index';
    import coordMap from "@/public/geoCoordMap";
    import axios from 'axios';
    import {
    initEchart1,
    initEchart2,
    initEchart3,
    initEchart4,
    initEchart5,
    initZhiweileibie,
    initmapEcharts,
    inithotSea,
    initIndustryEcharts,
    initGuimoEcharts,
    initxingzhiEcharts,
    inithenanmapEcharts
    } from '../public/homePageChart'
    export default {
        setup() {
            // 存储请求的 cancel token
            const cancelTokens = [];
            /**
             * 在组件卸载前取消所有请求
             * @description 遍历cancelTokens数组，取消每一个请求
             */
            onBeforeUnmount(() => {
                cancelTokens.forEach((cancelTokenSource) => {
                    cancelTokenSource.cancel('Component unmounted');
                });
            });
			var bgUrl = "url(\"../assets/image/border_default_bg_l.png\")";
			let backgroundJson =   localStorage.getItem('background');
			if(backgroundJson){
			    let background = JSON.parse(backgroundJson);
			    if(background.main){
                    bgUrl = background.main;
                }
			}
            const echart4Show = ref(true);
            const dialogVisible = ref(false);
            const mapData = ref([]);
            const provincialMapData = ref([]);
            const echart1 = ref(null);
            const echart2 = ref(null);
            const echart3 = ref(null);
            const echart4 = ref(null);
            const echart5 = ref(null);
            const mapEcharts = ref(null);
            const henanmapEcharts = ref(null);
            const zhiweileibieChart=ref(null);
            const hotSea = ref (null);
            const industryEcharts = ref (null);
            const guimoEcharts = ref (null);
            const xingzhiEcharts = ref (null);
            var initEchart7Fn = null;
            var initEchart12Fn = null;
            const series = null;
            const state = reactive({
                count: 0,
                title: '重点数据',
            })
            var mapSeries = null;
            let isHenan = ref (false);
            let mainDataObj = ref ({});
            let mapList = ref([])
            let henanmapList = ref([])
            //河南地图
            let gethenanmapChart = (mapList) =>{
                var total = 0;
                let allData = [];
                mapList.map((item) => {
                   if (item.name != '其他') {
                      allData.push([{
                        name: '开封市'
                       }, {
                        name: item.name,
                        value: item.count
                       }])
                        total += item.count
                   }
                });
                sethenanChartMap(allData,total);
            }

            let sethenanChartMap = (fromData, total)=>{
                var geoCoordMap = coordMap.henanCityData;
                var BJData = fromData;
                var convertData = function(data) {
                var res = [];
                for (var i = 0; i < data.length; i++) {
                    var dataItem = data[i];
                    var fromCoord = geoCoordMap[dataItem[0].name];
                    var toCoord = geoCoordMap[dataItem[1].name];
                    if (fromCoord && toCoord) {
                        res.push([{
                            coord: fromCoord
                        }, {
                            coord: toCoord
                        }]);
                    }
                }
                return res;
            };
            var color = ['#febd23', '#ffa022', '#a6c84c'];
            var series = [];

            console.log('BJData',BJData);
            [
            ['开封市', BJData]
            ].forEach(function(item, i) {
                series.push({
                    name: item[0] + ' Top10',
                    type: 'lines',
                    zlevel: 1,
                    effect: {
                        show: true,
                        period: 6,
                        trailLength: 0.7,
                        color: '#fff',
                        symbolSize: 3
                    },
                    lineStyle: {
                        normal: {
                            color: color[i],
                            width: 0,
                            curveness: 0.2
                        }
                    },
                    data: convertData(item[1])
                }, {
                    name: item[0] + ' Top10',
                    type: 'lines',
                    zlevel: 2,
                    effect: {
                        show: true,
                        period: 6,
                        trailLength: 0,
                        symbol: 'circle',
                        symbolSize: 4
                    },
                    lineStyle: {
                        normal: {
                            color: color[i],
                            width: 1,
                            opacity: 0.4,
                            curveness: 0.2
                        }
                    },
                    data: convertData(item[1])
                }, {
                    name: item[0] + ' Top10',
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    zlevel: 2,
                    rippleEffect: {
                        brushType: 'stroke'
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'right',
                            color:'#FFF',
                            formatter: '{b}'
                        }
                    },
                    symbolSize: function(val) {
                        return val[2] / total * 20;
                    },
                    itemStyle: {
                        normal: {
                            color: color[i]
                        }
                    },
                    data: item[1].map(function(dataItem) {
                        if(geoCoordMap[dataItem[1].name] !='其它'){
                            return {
                                name: dataItem[1].name,
                                value: geoCoordMap[dataItem[1].name].concat([dataItem[1].value])
                            };
                        }
                    })
                 });
                });
                mapSeries = series
                initEchart12Fn = inithenanmapEcharts(henanmapEcharts.value,series);
            }

            //中国
            let getmapChart = (mapList) => {
                var total = 0;
                let allData = [];
                mapList.map((item) => {
                   if (item.name != '其他') {
                      allData.push([{
                        name: '郑州市'
                       }, {
                        name: item.name,
                        value: item.count
                       }])
                        total += item.count
                   }
                });
                setChartMap(allData,total);
            }

            const setChartMap = (fromData, total) => {
              var geoCoordMap = coordMap.dataList;
              var BJData = fromData;
              var convertData = function(data) {
                var res = [];
                for (var i = 0; i < data.length; i++) {
                    var dataItem = data[i];
                    var fromCoord = geoCoordMap[dataItem[0].name];
                    var toCoord = geoCoordMap[dataItem[1].name];
                    if (fromCoord && toCoord) {
                        res.push([{
                            coord: fromCoord
                        }, {
                            coord: toCoord
                        }]);
                    }
                }
                return res;
            };
            var color = ['#febd23', '#ffa022', '#a6c84c'];
            var series = [];

            console.log('BJData',BJData);
            [
            ['郑州', BJData]
            ].forEach(function(item, i) {
                series.push({
                    name: item[0] + ' Top10',
                    type: 'lines',
                    zlevel: 1,
                    effect: {
                        show: true,
                        period: 6,
                        trailLength: 0.7,
                        color: '#fff',
                        symbolSize: 3
                    },
                    lineStyle: {
                        normal: {
                            color: color[i],
                            width: 0,
                            curveness: 0.2
                        }
                    },
                    data: convertData(item[1])
                }, {
                    name: item[0] + ' Top10',
                    type: 'lines',
                    zlevel: 2,
                    effect: {
                        show: true,
                        period: 6,
                        trailLength: 0,
                        symbol: 'circle',
                        symbolSize: 4
                    },
                    lineStyle: {
                        normal: {
                            color: color[i],
                            width: 1,
                            opacity: 0.4,
                            curveness: 0.2
                        }
                    },
                    data: convertData(item[1])
                }, {
                    name: item[0] + ' Top10',
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    zlevel: 2,
                    rippleEffect: {
                        brushType: 'stroke'
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'right',
                            color:'#FFF',
                            formatter: '{b}'
                        }
                    },
                    symbolSize: function(val) {
                        return val[2] / total * 20;
                    },
                    itemStyle: {
                        normal: {
                            color: color[i]
                        }
                    },
                    data: item[1].map(function(dataItem) {
                        if(geoCoordMap[dataItem[1].name] !='其它'){
                            return {
                                name: dataItem[1].name,
                                value: geoCoordMap[dataItem[1].name].concat([dataItem[1].value])
                            };
                        }
                        console.log('geoCoordMap[dataItem[1].name].concat([dataItem[1].value])',geoCoordMap[dataItem[1].name].concat([dataItem[1].value]));

                    })
                 });
                });

                mapSeries = series
                initEchart7Fn = initmapEcharts(mapEcharts.value,series);
            }

            const showBox = () => {
                dialogVisible.value = true
            }
            const closBox = () => {
                dialogVisible.value = false
            }
            onMounted( async () => {
                const cancelToken = axios.CancelToken.source();
                console.log('cancelToken.token',cancelToken);
                cancelTokens.push(cancelToken);
                let {data,status} = await basicApi.get_screen_stream(cancelToken.token);
                let mainData = data;
                // 临时补丁 河南职业技术学院数据强制更换且隐藏近5年累计宣讲会举办场次
                let collegeDetail = localStorage.getItem('collegeDetail')
                if (collegeDetail) {
                    collegeDetail = JSON.parse(collegeDetail)
                    if (collegeDetail.collegeid === '5e684b0395017e22b8929202') {
                        echart4Show.value = false;
                        mainData.student_signup_year_list.forEach(v => {
                            if (v.code === '2022') {
                                v.ratio = 0.9816;
                            }else if (v.code === '2023') {
                                v.ratio = 0.9805;
                            }   else if (v.code === '2024') {
                                v.ratio = 0.9791;
                            }
                        })
                    }
                }
                // 临时补丁结束
                let chinaNub = 0;
                for(let item of data.target_province_list){
                    chinaNub +=item.count;
                }
                for(let item of data.target_province_list){
                    item.radio = item.count/chinaNub;
                    console.log(item.radio);
                }

                let henanNub = 0;
               
                for(let item of data.target_city_list){
                    henanNub +=item.count;
                }
                for(let item of data.target_city_list){
                    item.radio = item.count/henanNub;
                    console.log(item.radio);
                }
                //地图数据
                mapList.value = data.target_province_list;
                henanmapList.value = data.target_city_list;
                getmapChart(mapList.value);
                gethenanmapChart(henanmapList.value);
                mainData.ratio = parseInt(mainData.ratio)+':1';//比例取整数
                mainDataObj.value = mainData;
                //近5届毕业生数量对比
                const initEchart1Fn = initEchart1(echart1.value,mainData.student_year_list);
                //近5届毕业生就业率
                const initEchart2Fn = initEchart2(echart2.value,mainData.student_signup_year_list);
                //近5年累计双选会举办场次
                const initEchart3Fn = initEchart3(echart3.value,mainData.milkround_year_list);
                //近5年累计宣讲会举办场次
                const initEchart4Fn = initEchart4(echart4.value,mainData.campustalk_year_list);
                //意向行业
                const initEchart5Fn = initEchart5(echart5.value, (mainData.target_industry_list || []).sort((a, b) => b.count - a.count));
                //意向薪资
                const initEchart6Fn = initZhiweileibie(zhiweileibieChart.value, (mainData.target_salary_list || []).filter(v=>v.name!=='其它').sort((a, b) => b.count - a.count));
                //本校毕业生热搜词
                const initEchart8Fn = inithotSea(hotSea.value,mainData.hotwords_list);
                //合作企业行业分布
                const initEchart9Fn = initIndustryEcharts(industryEcharts.value, (mainData.department_industry_list || []).filter(v=>v.name!=='其它').sort((a, b) => b.count - a.count));
                //合作企业规模分布
                const initEchart10Fn = initGuimoEcharts(guimoEcharts.value, (mainData.department_scale_list || []).sort((a, b) => b.count - a.count));
                //合作企业性质分布
                const initEchart11Fn = initxingzhiEcharts(xingzhiEcharts.value, (mainData.department_employer_type_list || []).sort((a, b) => b.count - a.count));


                window.onresize = function () {
                    if(initEchart1Fn){initEchart1Fn.resize();}
                    if(initEchart2Fn){initEchart2Fn.resize();}
                    if(initEchart3Fn){initEchart3Fn.resize();}
                    if(initEchart4Fn){initEchart4Fn.resize();}
                    if(initEchart5Fn){initEchart5Fn.resize();}
                    if(initEchart6Fn){initEchart6Fn.resize();}
                    if(initEchart7Fn){initEchart7Fn.resize();}
                    if(initEchart8Fn){initEchart8Fn.resize();}
                    if(initEchart9Fn){initEchart9Fn.resize();}
                    if(initEchart10Fn){initEchart10Fn.resize();}
                    if(initEchart11Fn){initEchart11Fn.resize();}
                    if(initEchart12Fn){initEchart12Fn.resize();}
                    if(mapSeries){
                        initEchart7Fn = initmapEcharts(mapEcharts.value,series);
                        initEchart12Fn = inithenanmapEcharts(henanmapEcharts.value,series);
                    }

                }

                setInterval(() => {
                    isHenan.value = !isHenan.value
                },8000)
            });


            return{
                echart4Show,
              mapData,
              provincialMapData,
              echart1,
              echart2,
              echart3,
              echart4,
              echart5,
              zhiweileibieChart,
              mapEcharts,
              henanmapEcharts,
              hotSea,
              industryEcharts,
              guimoEcharts,
              xingzhiEcharts,
              state,
              mainDataObj,
              setChartMap,
              mapList,
              henanmapList,
              dialogVisible,
              showBox,
              closBox,
              isHenan,
			  bgUrl
            }
        },
         methods: {

         }

    }
</script>

<style scoped>
    .page {
        width: 100%;
        height: 100vh;
        overflow: hidden;
        box-sizing: border-box;
        position: relative;
    }
    ::-webkit-scrollbar{width:0px}
    .content {
        height: 100%;
        background: url("../assets/image/page_default_bg.png") no-repeat;
        background-size: cover;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        padding:0 20px;
        box-sizing: content-box;
        overflow-y:auto;
    }
    .top-row {
        width: 100%;
    }
    .container-row {
        width: 100%;
        /*margin-top: 25px;*/
        margin-bottom: 25px;
    }
    .top-item {
        height: 200px;
        margin-bottom:25px;
    }

    .left-col {
        min-height: 700px;
    }
    .topHead {
        width: 100%;
        height: 100px;
        margin-bottom: 15px;
    }

    .topHead .b-title{
        width: 1040px;
        height: 109px;
        background: url("../assets/image/titlebg.png") no-repeat;
        background-size: 100% 109px;
        margin: 0 auto;
        text-align: center;
        font-size: 38px;
        font-weight: bold;
        color: #01EEDE;
        line-height: 90px;
    }

    .boxbgimage {
        background: url("../assets/image/border_default_bg.png") no-repeat;
        background-size: 100% 100%;
        padding: 0 16px 20px;
    }


    .echartBox{
        width: 100%;
        position: relative;
    }

    .echartBox .echart_padding{
        width: 100%;
    }
    .firstContainer{
        position: relative;
    }

    .firstContainer .flashing2{
        position: absolute;
        right: 0;
        top: 0;
    }

    .firstContainer .title{
        display: flex;
        align-items: center;
        margin: 20px 0 0 20px;
    }
    .firstContainer .title .tag{
        width: 3px;
        height: 20px;
        border-radius: 1px;
        background: #01EEDE;
    }

    .firstContainer .title .text{
        font-size: 16px;
        color: #01EEDE;
        margin-left: 10px;
        font-weight: bold;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow:ellipsis;
    }
    /* 中间顶部三个模块 */
    .top-col{
        overflow: hidden;
        padding-top: 8px;
    }

    .top-col .title{
        font-size: 24px;
        font-weight: 600;
        color: #84C7F7;
        line-height: 33px;
    }
    .top-col .val{
        font-size: 40px;
        color: #FFFFFF;
        font-weight: bold;
        line-height: 60px;
        background: linear-gradient(226deg, #F8E98E 0%, #EFB758 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .center-col{
        padding:0 20px;
    }
    /* .mapContainer{
        width: 100%;
        height: 520px;
    } */
    .mapContainer .sml{
        display: none;
        position: absolute;
        right: 6px;
        top: 6px;
        font-size: 14px;
        color: #01EEDE;
        font-weight: bold;
        z-index: 999;
    }

    .mapContainer .sml img{
        width: 14px;
        height: 14px;
        display: inline-block;
    }
    .center-bottom-col{
        padding: 20px;
        height: 283px;
        position: relative;
        background: url("../assets/image/border_default_bg.png") no-repeat;
        background-size: 100% 100%;
        padding-bottom: 20px;
    }
    .center-bottom-col img{
        opacity: .6;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
    }

    .center-bottom-col .title,.right-item-col .title{
        display: flex;
        align-items: center;
        margin: 20px 0 0 20px;
    }
    .center-bottom-col .title .tag,.right-item-col .title .tag{
        width: 3px;
        height: 20px;
        border-radius: 1px;
        background: #01EEDE;
    }
    .center-bottom-col .title .text,.right-item-col .title .text{
        font-size: 16px;
        color: #01EEDE;
        margin-left: 10px;
        font-weight: bold;
    }
    .right-col{
        width: 100%;
        position: relative;
        overflow: hidden;
    }
    .right-item-col .title{
        margin: 0 0 0 20px;
        padding-top: 20px;
    }

    .right-col .guimoEcharts{
        margin: 20px auto;
    }
    .right-col .guimoEcharts.active{
        margin-bottom: 0;
    }

    .sou-tag-box{
        position: relative;
        overflow: hidden;
    }

    .mapEcharts{
        height: 580px;
    }

    .mapEcharts.activenone{
        width: 0;
        overflow: hidden;
        height: 0 !important;
    }

    .map-rank{
        width: 150px;
        height: 306px;
        position: absolute;
        right: 6px;
        bottom: 40px;
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 9;
        overflow: hidden;
    }
    .alertBox{
        width: 100%;
        height: 100%;
        position: fixed;
        z-index: 999;
        background: rgba(0, 0, 0, 0.7);
        left: 0;
        top: 0;
        transition: all 0.8s ease-out 0s;
        display: none;
    }
    .alertBox.active{
        display: block;
    }
    .alertBox .map-rank{
        position: relative;
        top: 20%;
        margin: 0 auto;
    }
    .map-rank .title{
        display: flex;
        align-items: center;
        width: 100%;
        padding-left: 10px;
    }
    .map-rank .title .tag {
        width: 3px;
        height: 20px;
        border-radius: 1px;
        background: #01EEDE;
    }
    .map-rank .title .text {
        font-size: 16px;
        color: #01EEDE;
        margin-left: 10px;
        font-weight: bold;
    }
    .zhu-chart {
        display: flex;
        flex-direction: column;
    }
    .zhu-chart .item {
        display: flex;
        align-items: center;
        margin-top: 8px;
        justify-content: space-between;

    }
    .zhu-chart .item .tag {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        background: linear-gradient(90deg,rgba(248,147,145,1) 0%,rgba(239,88,93,1) 100%);
        border-radius: 2px;
        font-size: 12px;
        color: #ffffff;
        font-weight: bold;
    }
    .zhu-chart .item .text {
        font-size: 12px;
        color: #84C7F7;
        margin-left: 6px;
        line-height: 20px;
    }

    .zhu-chart .item .widthBox{
        width: 60px;
        height: 20px;
        margin-left: 12px;
        cursor: pointer;
    }

    .zhu-chart .item .width {
        width: 60px;
        height: 5px;
        background: #666666;
        border-radius: 2px;
        margin-top: 7px;
    }

      .zhu-chart .item .width.active{
          margin-top: 0;
          margin-left: 12px;
      }

    .width-item {
        background: linear-gradient(90deg,rgba(248,147,145,1) 0%,rgba(239,88,93,1) 100%);
        height: 5px;
        border-radius: 2px;
    }

    .zhu-chart .item .tag1 {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        background: linear-gradient(226deg,rgba(36,160,205,1) 0%,rgba(59,59,227,1) 100%);
        border-radius: 2px;
        font-size: 12px;
        color: #ffffff;
        font-weight: bold;
    }

    .zhu-chart .item .text {
        font-size: 12px;
        color: #84C7F7;
        margin-left: 4px;
    }

    .right-item-col.active{
        position: relative;
    }


    .right-item-col.active .animation_1{
        width: 88%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;

    }
    .right-item-col.active .animation_1 img{
        display: block;
        width: 260px;
        height: 260px;
        margin: 56px auto 0;
        -webkit-animation:rotating 5s linear infinite;
    }


    @-webkit-keyframes rotating{

        0%{-webkit-transform:rotate(0deg);}

        100%{-webkit-transform:rotate(360deg);}
    }
    /*动效*/
    .flashing2{
        -webkit-animation:flashing2 5s linear infinite;
    }
    .sou-tag-box .sou-tag{
        width: 171px;
        height: 4px;
        position: absolute;
        left: -171px;
        top: 0;
        -webkit-animation:toRight 5s linear infinite;
    }
    .center-bottom-col .line_ex,.right-col .line_ex{
        width: 210px;
        height: 63px;
        position: absolute;
        left: 0;
        top: -29px;
        opacity: .2;
        -webkit-animation: toRight2 8s linear infinite;
    }

    @-webkit-keyframes flashing2{
        0%{opacity:1;}
        50%{opacity:0}
        100%{opacity:1}
    }
    @-webkit-keyframes toRight{
        0%{left:-171px;
            opacity: .3;
        }
        20%{left:-171px;
            opacity: 1;
        }
        75%{
            opacity: 1;
        }
        100%{left:80%;
            opacity: 0;
        }
    }
    @-webkit-keyframes toRight2{

    0%{left:-10px;
        opacity: .2;}
    35%{
        opacity: .5;}   
    75%{
        opacity: .5;
    }
    85%{
        opacity: .2;
    }
    100%{left:520px;
        opacity: 0;}
}

@media screen and (max-width: 1441px) {
    .map-rank.pc{
        display: none;
    }
    .mapContainer .sml{
        display: block;
        cursor: pointer;
    }
}

@media screen and (max-width: 990px) {
    .center-col{
       padding: 0;
       margin-bottom: 26px;
    }
}
@media screen and (max-width: 900px) {
    .top-col{
        margin-top: 26px;
    }
}


@media screen and (max-width: 600px) {
        /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
        .content {
            padding: 5px;
        }
        .top-item {
            margin-bottom:5px;
        }
        .left-col {
            margin-bottom: 5px;
        }
        .container-row{
            margin-top: 0;
        }
        .content {
            height: 100%;
            background: url("../assets/image/page_mobile_default_bg.png") no-repeat;
            background-size: 100% 100%;
        }

        /**/
        .firstContainer .title .text{
            font-size: 14px;
        }
        .top-col .title{
            font-size: 16px;
        }
        .top-col .val{
            font-size: 30px;
        }
        .mapEcharts{
        margin-bottom: 26px;
         height: 420px !important;
        }
        .right-item-col.active .animation_1{
            padding-top: 20px;
        }
        .right-item-col.active .animation_1 img{
            width: 220px;
            height:220px;
            margin-left: 0;
        }
}
@media screen and (max-width: 540px) {
  .mapEcharts{
        height: 320px !important;
    }
    .top-col .title{
            font-size: 14px;
     }
    .top-col .val{
        font-size: 28px;
    }
    .center-bottom-col .line_ex,.right-col .line_ex{
        width: 210px;
        height: 63px;
        position: absolute;
        left: 0;
        top: -29px;
        opacity: .2;
        -webkit-animation: toRight2 4s linear infinite;
    }
      @-webkit-keyframes toRight2{

        0%{left:-10px;
            opacity: .2;}
        35%{
            opacity: .5;}
        75%{
            opacity: .5;
        }
        85%{
            opacity: .2;
        }
        100%{left:200px;
            opacity: 0;}
      }
}
</style>
